module.exports = __webpack_public_path__ + "media/icons/key-c-590ac061.svg";